import { Injectable, inject } from '@angular/core';
import { MapLoadingService } from '../map-loading.service';
import { filter } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapStyleService {
  private readonly mapLoadingService = inject(MapLoadingService);

  rectangleOptions: google.maps.RectangleOptions = {
    fillColor: '#00c255',
    fillOpacity: 0.1,
    strokeColor: '#00c255',
    strokeOpacity: 0.8,
  };

  initLargeGoogleMapOptions(
    options: google.maps.MapOptions = {},
  ): google.maps.MapOptions {
    options.zoom = 12;
    options.disableDefaultUI = false;
    options.panControl = false;
    options.fullscreenControl = false;
    options.mapTypeControlOptions = {
      mapTypeIds: ['styled_map'],
      style: google.maps.MapTypeControlStyle.DEFAULT,
    };
    options.streetViewControl = false;
    options.zoomControlOptions = {
      position: google.maps.ControlPosition.TOP_RIGHT,
    };
    options.mapTypeControl = false;
    options.mapTypeId = 'styled_map';
    return options;
  }

  /**
   * Style for maps.
   * @see https://snazzymaps.com
   * @protected
   */
  async getStyledMapType(): Promise<google.maps.StyledMapType> {
    await firstValueFrom(
      this.mapLoadingService.isMapLoaded$.pipe(
        filter((isLoaded) => !!isLoaded),
      ),
    );
    return new google.maps.StyledMapType(
      [
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.stroke',
          stylers: [
            { color: '#ffffff' },
            { visibility: 'on' },
            { gamma: 1 },
            { saturation: 0 },
            { lightness: 0 },
          ],
        },
        {
          featureType: 'poi', // disable default markers
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#abebc6' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#2ECC71' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ffffff' }, { lightness: 0.2 }],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#a6a6a6' }, { weight: 0.29 }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#FDFFDF' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#F1C40F' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#FBEEBD' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#F1C40F' }, { lightness: 29 }, { weight: 0.29 }],
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry',
          stylers: [{ color: '#FBEEBD' }], // ffeba1
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#F1C40F' }],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#a6a6a6' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#c0def2' }],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#0079CB' }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [
            {
              color: '#80ccff',
            },
          ],
        },
      ],
      { name: 'Padspin' },
    );
  }
}
